import * as types from './type'

const initialState = {
    loading: false,
    dataUsers: []
}

export const orgUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_ORG_START: 
            return {
                ...state,
                loading: true,
            }
        
        case types.UPDATE_ORG_SUCCESS:
            return {
                ...state,
                loading: false,
                dataUsers: action.payload
            }
        
        case types.UPDATE_ORG_ERROR:
            return {
                ...state,
                loading: false,
            }
        default:
            return state
    }
}